export * from "./CookieBanner";
export * from "./CookieSettingsModal";
export * from "./SettingsButton";
export * from "./StyledComponents"; // Optional
export * from "./types";
export * from "./consentUI";
import { ConsentManager } from "./ConsentManager";

export { ConsentManager as default };
